export function setPromptForRefreshDisabled(value: boolean): boolean {
  const htmlNode = document.querySelector('html');
  if (htmlNode) {
    htmlNode.dataset.isPromptForRefreshDisabled = (value) ? 'YES' : 'NO';
    return true;
  }

  return false;
}

export function isPromptForRefreshDisabled(): boolean {
  const htmlNode = document.querySelector('html');
  return !!htmlNode && htmlNode.dataset.isPromptForRefreshDisabled === 'YES';
}

export function getDateFromResNetInput(resNetDate: string): string | null {
  const matches = /^(\d{1,2})\/(\d{1,2})\/(\d{1,2})$/.exec(resNetDate);
  if (matches) {
    const month = (matches[1].length === 1) ? '0' + matches[1] : matches[1];
    const day = (matches[2].length === 1) ? '0' + matches[2] : matches[2];
    return '20' + matches[3] + '-' + month + '-' + day;
  }

  return null;
}